var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"header"},[_c('Logo')],1),_c('div',{staticClass:"content"},[_c('router-view')],1),_c('div',{staticClass:"footer"},[_c('Footer')],1),_c('div',{attrs:{"id":"vk_community_messages"}}),_c('Girl')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }